import { defineStore } from "pinia"
import axios from "axios"
import type { AxiosResponse } from "@/plugins/axios"
import moment from "@/utils/moment"
import {Device} from "@capacitor/device"

export interface OtpForm {
  phone: string
  register: boolean
  reset: boolean
}

export interface LoginForm {
  otp: string
}

export interface PinLoginForm {
  user_id: number
  pin: string
}


export const useUserStore = defineStore("user", {
  state: () => {
    return {
      user: null as App.Models.AuthUser | null
    }
  },
  actions: {
    sendOtp(form: OtpForm) {
      return axios.post("/auth/otp", form)
    },
    async login(form: LoginForm) {
      const response: AxiosResponse<{ access_token: string }> = await axios
        .post("/auth", form)
        .catch((e) => e)

      if (response.data.access_token) {
        localStorage.setItem("token", response.data.access_token)
        await this.loadUser(true)
      }

      return response
    },
    async pinLogin(form: PinLoginForm) {
      const response: AxiosResponse<{ access_token: string }> = await axios
        .post("/auth/pin-login", form)
        .catch((e) => e)

      if (response.data.access_token) {
        localStorage.setItem("token", response.data.access_token)
        await this.loadUser(true)
      }

      return response
    },
    async logout() {
      const deviceId = await Device.getId() || null
      await axios.delete("/auth", {
        data: {
          device_id: deviceId ? deviceId.identifier : undefined
        }
      }).catch((e) => e)
      this.user = null
      localStorage.removeItem('token')
    },
    async loadUser(force: boolean = false) {
      if (this.user && !force) {
        return this.user
      }
      const {
        data: { user }
      }: AxiosResponse<{ user: App.Models.AuthUser }> = await axios.get("/auth").catch((e) => e)
      this.user = user
      if (user) {
        moment.updateLocale('en', {
          week: {
            dow: user.settings.start_of_week
          }
        })
      }
      return user
    },
    async impersonate(userId: number) {
      const response: AxiosResponse<{ access_token: string }> = await axios
        .post("/auth/impersonate", {
          user_id: userId
        })
        .catch((e) => e)

      if (response.data.access_token) {
        localStorage.setItem("token", response.data.access_token)
        await this.loadUser(true)
      }

      return response
    },
    async stopImpersonating() {
      const response: AxiosResponse<{ access_token: string }> = await axios
        .delete("/auth/stop-impersonating")
        .catch((e) => e)

      if (response.data.access_token) {
        localStorage.setItem("token", response.data.access_token)
        await this.loadUser(true)
      }

      return response
    }
  }
})
